import { stringify } from 'qs';
import request from '../../../../../services/request';
import { url } from '../service-utils';

// 获取学校整个结构树
export async function getSchoolTree(params) {
  return request(`${url.url}/dept/tree?${stringify(params)}`);
}

// 获取部门岗位角色及对应成员
export async function getDeptRoleList(params) {
  return request(`${url.url}/deptRole/list?${stringify(params)}`);
}

// 岗位角色添加成员
export async function addRoleUser(params) {
  return request(`${url.url}/deptRole/linkRoleAndUser`, {
    method: 'post',
    data:params,
  });
}

// 岗位角色删除成员
export async function removeUserFromRole(params) {
  return request(`${url.url}/deptRole/removeUserFromRole`, {
    method: 'post',
    data:params,
  });
}

// 获取组织通讯录同步方式
export async function orgSyncType(params) {
  return request(`${url.url}/org/pc/sync/type?${stringify(params)}`);
}
